export default __webpack_public_path__ + "static/media/Glodani 8.d55c1456.jpg";